import './add-new-coupons.scss'
import React from 'react'
import { colors, space } from '@entur/tokens'
import { Heading5 } from '@entur/typography'
import { SmallAlertBox } from '@entur/alert'
import { SecondarySquareButton, SuccessSquareButton } from '@entur/button'
import { CheckIcon, CloseIcon } from '@entur/icons'
import { TextField } from '@entur/form'
import { BlueModal } from '../modal/blue-modal'

type ChangeValuesBlueModalProps = {
  setOpen: (isOpen: boolean) => void
  isOpen: boolean
  isLoading: boolean
  onSubmit: () => void
  errorMessage?: string
  onClose?: () => void
  onChange: (value: string) => void
}
export const AddNewCouponsModal: React.FC<ChangeValuesBlueModalProps> = ({
  setOpen,
  isOpen,
  isLoading,
  onSubmit,
  errorMessage,
  onClose,
  onChange,
}) => {
  const handleInputFieldChanged = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value)
    },
    [onChange]
  )

  const handleClose = React.useCallback(() => {
    onClose?.()
    setOpen(false)
  }, [onClose, setOpen])

  return (
    <BlueModal setOpen={setOpen} open={isOpen}>
      <Heading5 style={{ marginTop: 0, marginBottom: space.extraSmall2 }}>Legg til nye klipp</Heading5>
      <form
        className="add-new-coupons"
        data-cy="add-new-coupons"
        onSubmit={(e) => {
          e.preventDefault()
          onSubmit()
        }}
      >
        <section style={{ marginBottom: space.large }}>
          <p style={{ marginTop: 0 }}>
            Her kan du legge til nye klipp dersom de blir brukt ved et uhell eller en feil.
          </p>
          <TextField
            onChange={handleInputFieldChanged}
            type="number"
            label="Antall nye klipp"
            required
            data-cy="add-new-coupons-text-field"
          ></TextField>
        </section>
        {errorMessage && (
          <section style={{ marginBottom: space.small }}>
            <SmallAlertBox data-cy="add-new-coupons-alert-box" variant="error">
              {errorMessage}
            </SmallAlertBox>
          </section>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <SuccessSquareButton
            type="submit"
            loading={isLoading}
            style={{ marginRight: space.extraSmall }}
            aria-label="Lagre"
            data-cy="add-new-coupons-confirm"
          >
            <CheckIcon size="1.25rem" aria-hidden color={colors.brand.blue} />
          </SuccessSquareButton>
          <SecondarySquareButton
            type="button"
            onClick={handleClose}
            className="cancel-button"
            aria-label="Lukk"
            data-cy="add-new-coupons-cancel"
          >
            <CloseIcon size="1.25rem" aria-hidden color={colors.brand.blue} />
          </SecondarySquareButton>
        </div>
      </form>
    </BlueModal>
  )
}
